import type { AuthStatus, ViewerProfileStatus } from '../auth/profileState';

type AuthControlAction = 'sign_in' | 'review_legal';

interface AuthControlModel {
  label: string;
  interactive: boolean;
  action: AuthControlAction | null;
}

export function authControlModel(
  authStatus: AuthStatus,
  profileStatus: ViewerProfileStatus,
): AuthControlModel {
  if (authStatus === 'disabled') {
    return {
      label: 'AUTH ENV MISSING',
      interactive: false,
      action: null,
    };
  }

  if (authStatus === 'loading') {
    return {
      label: 'AUTH LOADING',
      interactive: false,
      action: null,
    };
  }

  if (authStatus === 'signed_in') {
    if (profileStatus === 'legal_required') {
      return {
        label: 'LEGAL REQUIRED',
        interactive: true,
        action: 'review_legal',
      };
    }

    return {
      label: 'SIGNED IN',
      interactive: false,
      action: null,
    };
  }

  return {
    label: authStatus === 'error' ? 'AUTH ERROR' : 'SIGNED OUT',
    interactive: true,
    action: 'sign_in',
  };
}
